import { Columns, Container, Heading } from "react-bulma-components";
import { useLocation } from "react-router-dom";

// 404 Not Found Page when URL cannot find contents
const PageNotFound = () => {
  // useLocation is used to check URL
  let location = useLocation();

  // UseLocation is utilised in conditional statements
  let html = (
    // For wildcard URL search
    <Columns.Column>
      <Heading textColor="info" textSize={1} textWeight="bold">
        404 Not Found.
      </Heading>
      <Heading textColor="dark" subtitle>
        URL {location.pathname} does not exist.
      </Heading>
    </Columns.Column>
  );

  // For search input
  if (location.pathname === "/search/") {
    html = (
      <Columns.Column>
        <Heading textColor="info" textSize={1} textWeight="bold">
          404 Not Found.
        </Heading>
        <Heading textColor="dark" subtitle>
          Your search cannot be found in our database.
        </Heading>
      </Columns.Column>
    );
  }

  // For country URL path
  if (location.pathname === "/country/") {
    html = (
      <Columns.Column>
        <Heading textColor="info" textSize={1} textWeight="bold">
          404 Not Found.
        </Heading>
        <Heading textColor="dark" subtitle>
          URL /country does not exist.
        </Heading>
      </Columns.Column>
    );
  }

  // Display 404 contents
  return (
    <Container textAlign="center" my={6}>
      {html}
    </Container>
  );
};

export default PageNotFound;
